"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayOrderWithCardAxeptaResponseMapper = void 0;
class PayOrderWithCardAxeptaResponseMapper {
    toDomain(raw) {
        var _a, _b, _c;
        const data = (_a = raw === null || raw === void 0 ? void 0 : raw.data) === null || _a === void 0 ? void 0 : _a.payOrderWithCardAxepta;
        return {
            redirectUrl: (_c = (_b = data === null || data === void 0 ? void 0 : data._links) === null || _b === void 0 ? void 0 : _b.redirect) === null || _c === void 0 ? void 0 : _c.href,
        };
    }
}
exports.PayOrderWithCardAxeptaResponseMapper = PayOrderWithCardAxeptaResponseMapper;
